import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

export const NegativeBalanceWarning = () => (
  <div
    role="alert"
    className="flex w-full items-center gap-2.5 rounded-xl bg-interface-warning-1 px-4 py-3 text-interface-neutral-6"
  >
    <FontAwesomeIcon
      icon={faTriangleExclamation}
      className="shrink-0 text-interface-warning-4"
    />

    <p className="text-base">
      <T _str="This order will place the user into a negative balance." />
    </p>
  </div>
);
